import PATH from "constants/path";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ListNews, Notice } from "components";
import { getEntries, setMessageUpdateSuccess } from "features/Entries/entrySlice";
import { SERVICE } from "constants/global";
import ErrorDB from "components/ErrorDB";

import CardEntry from "features/Entries/components/CardEntry";
import ModalManager from "features/Entries/components/Modal/ModalManager";

function Entries() {
  const dispatch = useDispatch();

  const [modalOpen, setModalOpen] = useState(false);
  const [entrySetting, setEntrySetting] = useState();

  const { entries, newsInit, noticesInit, isInLine, isInLineEntry, isInLineNotice, isInLineNew, messageUpdateSuccess } = useSelector(
    (state) => state.entry
  );

  const closeModal = () => {
    if (messageUpdateSuccess) {
      dispatch(setMessageUpdateSuccess(false));
    };
    setEntrySetting(null);
    setModalOpen("");
  };

  useEffect(() => {
    dispatch(getEntries({ service: SERVICE }));
  }, []);

  if (!entries && !isInLine && !isInLineEntry && !isInLineNotice && !isInLineNew) return null;

  return (
    <>
      <div className="w-80 py-0 py-md-3">
        <Notice noticesInit={noticesInit} isInLine={isInLine || isInLineNotice}/>

        <div className="fs-20 fs-sm-18 text-center fw-600 my-2 my-md-4">
          応募中案件
        </div>
        {
          isInLine || isInLineEntry ?
          <ErrorDB/>
          :
          <div className="px-3 px-md-0">
          {entries?.length > 0 ? (
            entries.map((item) => (
              <CardEntry
                key={item.entry_id}
                entry={item}
                openModal={setModalOpen}
                setEntrySetting={setEntrySetting}
              />
            ))
          ) : (
            <>
              <div className="border-color-red-light border-radius-sm-5 p-2 text-center fw-bolder text-red-light">
                応募中案件はありません
              </div>
              <div className="text-center my-5">
                <a href={PATH.TOP} className="btn-custom red-light">
                  モニター募集一覧を見る
                </a>
              </div>
            </>
          )}
          </div>
        }
        

        <hr />

        <ListNews newsInit={newsInit} isInLine={isInLine || isInLineNew}/>
      </div>

      {entrySetting && (
        <ModalManager
          openModal={setModalOpen}
          closeModal={closeModal}
          entry={entrySetting}
          modal={modalOpen}
        />
      )}
    </>
  );
}

export default Entries;
